export default {
  BUILDER_MODE_KEY:   'builder_mode',
  RPID:               "rpid",
  DEFAULT_RPID:       '000000',
  COMMAND:            "command",
  DESIGN_UUID:        "design_uuid",
  HBUUID:             "hbuuid",
  EDIT:               "edit",
  BUILD:              "build",
  DIAMOND:            'diamond',
  SETTING:            'setting',
  DYO:                'dyo',
  DYO_STYLE_ID:       'RB001',
  RING_STYLE:         'ring_style',
  SHAPE:              'shape',
  TYPE:               'type',
  CARAT:              'carat',
  CROWN:              'crown',
  SIDE:               'side',
  METAL:              'metal',
  CROWN_METAL:        'crown_metal',
  SIZE:               'size',
  BAND:               'band',
  FIRST_BAND_METAL:   'first_band_metal',
  SECOND_BAND_METAL:  'second_band_metal',
  JOURNEY:            "journey",
  RING_BUILDER:       "ring_builder",
  Side_Stones:        "side_stones",
  Earring_Back:       "earring_back",
  Diamond_Quality:    "diamond_quality",
  STUD_CATEGORY_CODE: "EAR",
  RING_CATEGORY_CODE: "RNG",
  SUSTAINABLE_CRAFTED :'sustainable'
};
